// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-body {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 45px;
}
.navbar {
  position: fixed;
  left: 15px;
  top: 80px;
  width: 13%;
  max-height: 50%;
  margin-left: 15px;
  overflow-y: auto;
}
@media (max-width: 767px) {
  .markdown-body {
    padding: 15px;
  }
  .common-section {
    width: 100%;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/documents/components/Markdown/github-markdown.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,cAAA;EACA,aAAA;AACF;AAEA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAAF;AAGA;EACE;IACE,aAAA;EADF;EAGA;IACC,WAAA;IACA,UAAA;EADD;AACF","sourcesContent":[".markdown-body {\n  box-sizing: border-box;\n  margin: 0 auto;\n  padding: 45px;\n}\n\n.navbar {\n  position: fixed;\n  left: 15px;\n  top: 80px;\n  width: 13%;\n  max-height: 50%;\n  margin-left: 15px;\n  overflow-y: auto;\n}\n\n@media (max-width: 767px) {\n  .markdown-body {\n    padding: 15px;\n  }\n  .common-section {\n   width: 100%;\n   padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
